<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Force Mobile Verification
    </div>
    <form name="ForceMobileVerification" (ngSubmit)="Validate(ForceMobileVerification)"
        #ForceMobileVerification="ngForm" class="pb-2" novalidate>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <label for="DefaultShift" class="form-label text-label-dark">Employee Type : </label>
                    <div class="btn-group btn-group-toggle" (change)="onChange()">
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='front' name='EMPType'
                                [(ngModel)]="Detail.EmpType" [ngModelOptions]="{standalone: true}">
                            Front
                        </label>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='back' name='EMPType'
                                [(ngModel)]="Detail.EmpType" [ngModelOptions]="{standalone: true}">
                            Back
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Branch</label>
                    <ng-select name="Branchmaster" id="Branchmaster" [items]="BranchMaster" bindLabel="BranchName"
                        bindValue="BranchMasterID" [(ngModel)]="Detail.BranchId"
                        (change)="onSelectChange('Branch');ComboLoad('Client');" #Branchmaster="ngModel"
                        placeholder="Select Branch">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch!
                    </div>
                </div>
                <div class="col-md-4 px-1" *ngIf="Detail.EmpType === 'front'">
                    <label class="form-font-label">Client</label>
                    <ng-select name="Client" id="Client" [items]="ClientMaster" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" (change)="onSelectChange('Client');ComboLoad('Site')"
                        [(ngModel)]="Detail.ClientId" #Branch="ngModel" placeholder="Select Client">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Client!
                    </div>
                </div>
                <div class="col-md-4 px-1" *ngIf="Detail.EmpType === 'front'">
                    <label class="form-font-label">Site</label>
                    <ng-select name="Site" id="Site" [items]="SiteMaster" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="Detail.SiteId" #Branch="ngModel" (change)="onSelectChange('Site');"
                        placeholder="Select Site">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Site!
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 px-1">
                    <label class="form-font-label">Emp Code</label>
                    <input type="text" class="form-control" name="empcode" placeholder="Ex. "
                        [(ngModel)]="Detail.EmpCode" #empcode="ngModel" rows="2">
                </div>
                <div class="col-md-3 px-1"><br>
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-search"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}</button>
                </div>
            </div>
        </div>
        <div *ngIf="isDisabled" class="loading-spinner">
            <p>Loading...</p>
        </div>
        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px;">#</th>
                                <th scope="col">Branch</th>
                                <th scope="col" *ngIf="Detail.EmpType === 'front'">CustomerGroup</th>
                                <th scope="col" *ngIf="Detail.EmpType === 'front'">Site</th>
                                <th scope="col" style="display: none;">EmpMasterID</th>
                                <th scope="col">EmpCode</th>
                                <th scope="col">EmpType</th>
                                <th scope="col">Name</th>
                                <!-- <th scope="col">
                                    IsMobileVerificationMandatory
                                </th> -->
                                <th scope="col" style="width: 5px;">
                                    <input type="checkbox" name="all" (change)="selectAll($event)">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let shift of ESS_ForceMobileVerification; let i = index">
                                <th scope="row" style="width: 5px;">{{ i + 1 }}</th>
                                <td>{{ shift.Branch }}</td>
                                <td *ngIf="Detail.EmpType === 'front'">{{ shift.CustomerGroup }}</td>
                                <td *ngIf="Detail.EmpType === 'front'">{{ shift.Site }}</td>
                                <td style="display: none;">{{ shift.EmpMasterID }}</td>
                                <td>{{ shift.EmpCode }}</td>
                                <td>{{ shift.EmpType }}</td>
                                <td>{{ shift.Name }}</td>
                                <!-- <td>{{ shift.IsMobileVerificationMandatory }}</td> -->
                                <td>
                                    <input type="checkbox" name="single{{i}}"
                                        [(ngModel)]="shift.IsMobileVerificationMandatory"
                                        (change)="selectRow($event, shift)">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button *ngIf="this.common.PageRight.IsEdit || this.common.PageRight.IsAdd" type="button"
                    class="btn btn-primary" [disabled]="isDisabled" (click)="ESS_ReimbursementRequest_Insert()"><i
                        class="bi bi-pass" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Update':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>